import { Component, DestroyRef, EventEmitter, Output, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '../../../_services/auth.service';
import { BrandingService } from '../../../_services/branding.service';
import { environment } from '../../../../environments/environment';
import { EMEA_REGION_CODES } from '../../../_enums/auth-server-environment';
import { User } from '../../../_interfaces/user';
import { resolveAvatarUrl, resolveSupportUrl } from '../../../_helpers/user.helper';
import { AnalyticsService } from '../../../_services/analytics.service';

@Component({
  selector: 'app-mobile-home-menu',
  standalone: true,
  imports: [NgClass, RouterLink, RouterLinkActive, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './mobile-home-menu.component.html',
  styleUrl: './mobile-home-menu.component.scss',
  host: {
    class: 'block md:hidden sticky top-0 z-50 shrink-0',
  },
})
export class MobileHomeMenuComponent {
  @Output() logoutClick = new EventEmitter<void>();

  user: User | null = null;
  isExpanded = false;
  isLegalOrg = false;

  private readonly destroyRef = inject(DestroyRef);
  private readonly authService = inject(AuthService);
  private readonly translate = inject(TranslateService);
  private readonly analytics = inject(AnalyticsService);
  readonly branding = inject(BrandingService);

  constructor() {
    this.authService.user$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(user => {
        this.user = user;
        this.isLegalOrg = user?.entity?.settings?.category === 'Legal';
      });
  }

  get showMdrInformation(): boolean {
    if (this.isLegalOrg) return false;
    return EMEA_REGION_CODES.has(environment.regionCode);
  }

  get isAiBlueprintsEnabled(): boolean {
    return this.authService.isAiBlueprintsEnabled;
  }

  get avatarUrl(): string | null {
    return resolveAvatarUrl(this.user?.profile?.avatar_url);
  }

  get supportUrl(): string {
    return resolveSupportUrl(this.user, this.translate.currentLang);
  }

  toggleMenu(): void {
    this.isExpanded = !this.isExpanded;
  }

  closeMenu(): void {
    this.isExpanded = false;
  }

  onLogout(): void {
    this.closeMenu();
    this.logoutClick.emit();
  }

  onSupportClick(): void {
    this.analytics.track('support_clicked', { entry_point: 'mobile_home_menu' });
    this.closeMenu();
  }
}
